module.exports = __webpack_public_path__ + "static/media/close.b8c4e3a9.svg";